// extracted by mini-css-extract-plugin
export default {"container":"SearchForm_container__pe-VG","form":"SearchForm_form__WMQZo","input":"SearchForm_input__Igezi","button":"SearchForm_button__U3hWC"};